export default "__VITE_ASSET__e729d705__"